import React, { useEffect } from "react"

// redux
import { mapDispatchProps, mapStateToProps } from "../../../store/store"
import { connect } from "react-redux"

import { useLocation, useNavigate } from "react-router-dom"

import Button from "../../../components/button"
import { ROUTES } from "../../../routes"
import API from "../../../api"
import { useLanguage } from "@languages/index"

const SNSPaymentComplete = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.sns }
  const navigate = useNavigate()
  const location: any = useLocation()

  const fetchBrand = () => {
    API.Brand.show({ brandToken: props.auth.token })
      .then((response) => {
        props.setBrand(response.data.brand)

        if (response.data.brand.hasExperiencedSnsInstall && !response.data.brand.snsPassInstalledAt) {
          navigate(ROUTES.SNS_PAYMENT_COMPLETE.PATH)
        }
      })
      .catch((error) => {
        props.showModal({
          text: languageTexts.celeb_detail_text_1,
        })
      })
  }

  useEffect(() => {
    fetchBrand()
  }, [])

  const renderPageTitle = () => {
    return (
      <div className="flex flex-col items-center gap-[30px]">
        <div className="flex flex-row justify-center">
          <div className="w-[5rem] h-[5rem]">
            <img src="/assets/icons/ic-check-blue-circle.svg" />
          </div>
        </div>
        <div className="flex font-bold text-center justify-center text-[2.25rem]">
          {languageTexts.payments_complete_text_1}
        </div>
      </div>
    )
  }

  const renderDescription = () => {
    return (
      <div className="flex flex-col p-6 gap-3 border border-gray-200 rounded my-[64px]">
        <div className="flex flex-col justify-center text-center text-[15px]">
          {languageTexts._payments_complete_text_2(props.settings.durationSnsPass)}
        </div>
      </div>
    )
  }

  const renderConfirmButton = () => {
    return (
      <div className="flex flex-col">
        <Button
          bordered
          text={languageTexts.confirm}
          textColor={"WHITE"}
          buttonColor={"#121212"}
          borderColor={"#121212"}
          onClick={() => {
            navigate(ROUTES.SNS_INDEX.PATH, { replace: true })
          }}
        />
      </div>
    )
  }

  return (
    <>
      <div className="px-5 mx-auto h-[100dvh] flex flex-col justify-center" style={{ maxWidth: "450px" }}>
        {renderPageTitle()}
        {renderDescription()}
        {/* {renderConfirmButton()} */}
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(SNSPaymentComplete)
